import { API } from 'aws-amplify';
import { authHeader } from 'utils/auth';

export async function saveAccountToken(
  reportId: string,
  publicToken: string,
  hrisProvider: string
): Promise<boolean> {
  const apiName = 'mergeCredentialAPI';
  const path = `/report/${reportId}/merge-credential/save-account-token?hrisProvider=${hrisProvider}`;
  const headers = await authHeader();
  try {
    await API.post(apiName, path, {
      headers,
      body: {
        publicToken
      }
    });
    return true;
  } catch (error) {
    console.log('Error: ', error);
    return false;
  }
}

export async function createLinkToken(reportId: string, integration: string): Promise<string> {
  const apiName = 'mergeAPI';
  const path = `/report/${reportId}/merge/create-link-token?integration=${integration}`;
  const headers = await authHeader();
  const { link_token: token } = await API.post(apiName, path, {
    headers
  });
  return token;
}

export async function saveGustoAccessToken(reportId: string, code: string): Promise<boolean> {
  const apiName = 'gustoAPI';
  const path = `/report/${reportId}/gusto/save-access-token`;
  const headers = await authHeader();
  try {
    await API.post(apiName, path, {
      headers,
      body: {
        code
      }
    });
    return true;
  } catch (error) {
    console.log('Error: ', error);
    return false;
  }
}
